export default "__VITE_ASSET__D0PB7jQM__"